import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=87e58e42&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=87e58e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e58e42",
  null
  
)

export default component.exports